import React from 'react' 
import Navbar from './Navbar'
import RegisterSVPForm from './RegisterSVPForm'

const QuickRegisterSVP = (props) => {
    return (
        <div>
            <Navbar />
            <br></br>
            <br></br>
            <br></br>
            <RegisterSVPForm />
        </div>
    )
}

export default QuickRegisterSVP
